import EmptyResult from '@/app/[lng]/(home)/search/EmptyResult'
import { AdBannerScheduleType } from '@/app/types/adType'
import { NewsSearchResponse } from '@/app/types/newsSearchType'
import LimitPagination from '@/components/LimitPagination'
import { useParams } from 'next/navigation'
import { useEffect, useOptimistic, useTransition } from 'react'
import CommonNewsList from './CommonNewsList'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'
interface RetailnewsFitlerType {
  newsData: NewsSearchResponse
  isLoading: boolean
  adData: AdBannerScheduleType[]
}

const RetailNewsResults = ({
  newsData,
  isLoading,
  adData,
}: RetailnewsFitlerType) => {
  // newsPageNo
  const { newsPageNo } = useParams<{ lng: string; newsPageNo: string[] }>()
  const [isPending, startTransition] = useTransition()
  const [optimisticPageNo, setOptimisticPageNo] = useOptimistic<number>(
    Number(newsPageNo?.[0] || 1)
  )
  const goToPage = usePageNumberUpdator()
  const isDataEmpty = !isLoading && newsData?.news.length == 0 && !isPending

  // const { data: newsAds = [] } = useGetAdsQuery<{
  //   data: AdBannerScheduleType[]
  //   isLoading: boolean
  //   isError: boolean
  //   isFetching: boolean
  // }>({ page: AD_PAGE, lang: lng })
  const adFilter5 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 5')[0] ?? {}
  const adFilter6 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 6')[0] ?? {}
  const adFilter7 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 7')[0] ?? {}

  const adsData = [adFilter5, adFilter6, adFilter7]
  const handlePageChange = (page: number) => {
    startTransition(() => {
      setOptimisticPageNo(page)
      goToPage({ newPageNo: page })
    })
  }

  useEffect(() => {
    if (newsData) {
      if (!newsData?.news?.length && Number(newsPageNo?.[0] || 1) !== 1) {
        handlePageChange(1)
      }
    }
  }, [newsData])
  return (
    <div className=" flex flex-col gap-5">
      <CommonNewsList
        newsData={newsData}
        isNewsDataLoading={isLoading}
        adsData={adsData}
      />
      <div className="mt-[35px] border-t-2 border-t-[#e6e6e6] border-solid mobile:mt-[10px]">
        {!isDataEmpty && (
          <LimitPagination
            currentPage={optimisticPageNo}
            pageCount={Math.ceil(newsData?.count / 10) || 1}
            visiblePages={5}
            onPageChange={(page) => handlePageChange(page)}
          />
        )}
      </div>
      {isDataEmpty && <EmptyResult searchTerm={''} />}
    </div>
  )
}

export default RetailNewsResults
